export default "<button mat-menu-item>\n  <span class=\"font-size-md color-text-base\">{{ name }}</span>\n</button>\n";